import "../../assets/css/modal.css";
import "../../assets/css/custom.css";
import { useEffect, useRef, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import testImng from "../../assets/images/icon/heart.png";
import { FaTrashAlt } from "react-icons/fa";
import { useRecoilValue } from "recoil";
import { apiProductsState } from "../../atom/Products";
import { apiKeyState } from "../../atom/ApiKey";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import ApiMobailBar from "../button/ApiMobailBar";
export default function TestAPiMobileModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  const scrollRef = useRef(null);
  const apiProducts = useRecoilValue(apiProductsState);
  const apiKeys = useRecoilValue(apiKeyState);
  const [isValue, setValue] = useState("1");

  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };
  return (
    <div className="modal-mobile-overlay" onClick={onClose}>
      <div
        className="modal-mobile-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <div className="modal-mobile-header">모달 해더</div>
          <hr color="black" />
        </div>
        <div>
          <div className="scroll-wrapper">
            {/* <button className="scroll-btn left" onClick={handleScrollLeft}>
              <IoIosArrowBack />
            </button> */}
            <div className="modal-mobile-tab" ref={scrollRef}>
              <div
                className={`modal-mobile-tab-select ${
                  isValue === "1" ? "active" : ""
                }`}
                onClick={() => setValue("1")}
              >
                신청가능한 API
              </div>
              <div
                className={`modal-mobile-tab-select ${
                  isValue === "2" ? "active" : ""
                }`}
                onClick={() => setValue("2")}
              >
                사용중인 API
              </div>
            </div>
            {/* <button className="scroll-btn right" onClick={handleScrollRight}>
              <IoIosArrowForward />
            </button> */}
          </div>
          <div className="modal-mobile-list-box">
            {isValue === "1" &&
              apiProducts.map((item, index) => (
                <ApiMobailBar key={index} data={item} />
              ))}
            {isValue === "2" &&
              apiKeys.map((item, index) => (
                <ApiMobailBar key={index} data={item} />
              ))}
          </div>
          <div className="modal-mobile-bottom-button-box">
            {/* <button className="modal-mobile-bottom-button">취소</button>
          <div style={{ width: `20px` }}></div> */}
            <button className="modal-mobile-bottom-button2" onClick={onClose}>
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
